import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Archive = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M3.75 12.75h4.32a4.001 4.001 0 0 0 7.86 0h4.32m-3 7.5H6.75a3 3 0 0 1-3-3V6.75a3 3 0 0 1 3-3h10.5a3 3 0 0 1 3 3v10.5a3 3 0 0 1-3 3'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='square'
        strokeLinejoin='round'
      />
    ) : (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3 13.746V6.75A3.75 3.75 0 0 1 6.75 3h10.5A3.75 3.75 0 0 1 21 6.75v10.5A3.75 3.75 0 0 1 17.25 21H6.75A3.75 3.75 0 0 1 3 17.25M6.75 4.5h10.5a2.25 2.25 0 0 1 2.25 2.25V13h-3.57a.75.75 0 0 0-.737.61 3.251 3.251 0 0 1-6.386 0A.75.75 0 0 0 8.07 13H4.5V6.75A2.25 2.25 0 0 1 6.75 4.5'
          fill='currentColor'
        />
        <path d='M3 17.25v-3.504' fill='currentColor' />
      </>
    )}
  </IconBase>
);
